<template>
  <div @keydown.enter.prevent="preventDefault" :style="labelStyles" class="annotate-labels">
    <search-label-autocomplete
        :placeholder="computedPlaceholder"
        :label_type="annotateLabelType"
        :clear_on_select="placementMode"
        :disabled="disabled"
        :ensure_text_line_label="type === 'box'"
        :ensure_blackout_label="type === 'box'"
        :allow_create_label="canManageLabels"
        :create_label_type="annotateLabelType === 'point' ? 2 : 1"
        @label-selected="on_select_label"
    ></search-label-autocomplete>
    <v-chip
      v-if="placementMode && selectedLabelName"
      size="x-small"
      color="primary"
      variant="tonal"
      class="mt-1"
    >
      {{ selectedLabelName }}
    </v-chip>
  </div>
</template>

<script>

import Annotation from "@/classes/annotation";
import SearchLabelAutocomplete from "@/components/SearchLabelAutocomplete.vue";
import CurrentUserMixin from "@/mixins/CurrentUserMixin.vue";
const { v4: uuidV4 } = require('uuid');

export default {
  name: "AnnotateLabels",
  mixins: [CurrentUserMixin],
  components: { SearchLabelAutocomplete },
  props: {
    placeholder: {default: null},
    type: null,
    disabled: { type: Boolean, default: false },
    placementMode: { type: Boolean, default: false },
    selectedLabelName: { type: String, default: null },
  },
  computed: {
    annotateLabelType() {
      if (this.type === 'box') {
        return 'box';
      }
      if (this.type === 'point') {
        return 'point';
      }
      return null;
    },
    labelStyles() {
      return this.disabled ? { opacity: 0.5, pointerEvents: 'none' } : {};
    },
    translatedPlaceholder() {
      return this.$t('set_label_groups.annotate_labels_placeholder');
    },
    canManageLabels() {
      return this.can_manage_labels;
    },
    computedPlaceholder() {
      if (this.placementMode) {
        const key = this.type === 'point'
          ? 'annotate.placement_placeholder_point'
          : 'annotate.placement_placeholder_box';
        return this.$t(key);
      }
      let returnString = this.computedType + " ";
      returnString += this.placeholder !== null ? this.placeholder : this.translatedPlaceholder;
      return this.capitalizeFirstLetter(returnString);
    },
    translatedType() {
      return this.$t('set_label_groups.annotate_labels_type');
    },
    computedType() {
      return this.type !== null ? this.type : this.translatedType;
    },
  },
  methods: {
    preventDefault() {},
    capitalizeFirstLetter(returnString) {
      returnString = returnString.toLowerCase();
      return returnString.charAt(0).toUpperCase() + returnString.slice(1);
    },
    on_select_label(label) {
      if (!label) {
        return;
      }
      let color = [0, 180, 0];
      if (label.color) {
        color = label.color.split(',');
      }

      if (this.placementMode) {
        this.$emit('label_selected', {
          type: this.type,
          name: label.name,
          color_values: color,
        });
        return;
      }

      let id = uuidV4();
      let coords = [0.5, 0.5];
      if (this.type === 'box') {
        coords = [0.4, 0.4, 0.2, 0.2];
      }
      let annotation = new Annotation(id, this.type, coords, 1.0, label.name, color);
      this.$emit('add_annotation', annotation);
    },
  },
};
</script>

<style scoped>
.annotate-labels {
  margin-bottom: 8px;
}
</style>
